<template>
    <div class="main-wrap" id="mainWrap">
        <KHeader :scrollTop="scrollTop"></KHeader>
        <div class="content">
            <RouterView></RouterView>
        </div>
        <KFooter></KFooter>
        <KBacktop :show="showBackTop"></KBacktop>
    </div>
</template>

<script>
    import KHeader from "../components/kllk-header-nav"
    import KFooter from "../components/kllk-footer-nav"
    import KBacktop from "../components/kllk-backtop.vue"
    import {throttle} from "throttle-debounce"

    export default {
        name: 'HelloWorld',
        components: {KHeader, KFooter, KBacktop},
        data() {
            return {
                scrollTop: true,
                showBackTop: false
            }
        },
        created() {
            this.scrollTop = this.$route.path === "/home";
        },
        mounted() {
            this.throttledScrollHandler = throttle(300, this.onScroll);
            this.$el.addEventListener('scroll', this.throttledScrollHandler);
        },
        methods: {
            onScroll() {
                const scrollTop = this.$el.scrollTop;
                if (this.$route.path === "/home") {
                    this.scrollTop = scrollTop <= 5;
                }
                this.showBackTop = scrollTop >= 100;
            },
        },
        watch: {
            $route() {
                this.$el.scrollTop = 0;
                this.scrollTop = this.$route.path === "/home";
            }
        },
        beforeDestroy() {
            this.$el.removeEventListener('scroll', this.throttledScrollHandler);
        }
    }
</script>

<style lang="less" scoped>
    @import "../style/constant.less";

    .main-wrap {
        overflow: auto;
        height: 100%;

        .content {
            margin-top: 70px;
            min-height: 90vh;
        }
    }


</style>
